
import services from '../../services'
import dateUtil from '@/utils/date'

const state = {
    carRules: [],
    carTypeInfo: {},
    vehicleWay: [],
    lockInfo: {},
    vehicleTimeSet: {},
    dateTimeStr: '',
    pageVO: {
        curPage: 1,
        pageSize: 10
    },
    busPageInfo: {
        curPage: 1,
        pageSize: 10,
        totalRows: 20
    },
    // 用于用车预订列表右侧删除时，关联左侧改变数据
    busLeftData: [],
    // 用于存储预订右侧列表数据
    rigthBookingList: [],
    // 用于存储已选日期
    busDateTimeList: [],
    // 用于存储申请列表右侧显示信息
    busApplyRightList: [],
    // 用于展示隐藏车辆表格
    isVehicleIndex: -1,
    // 取消规则文本查询
    vehRulesHtml: '',
    // 商旅用车价格列表
    busVehiclePricelist: [],
    // 商旅用车乘客人数列表
    passengersNumberList: [],
    // 用车类型
    vehicleTypeList: [],
    // 乘车用途下拉数据
    usageOption: [],
    // 车型
    vehicleModelList: [],
    // 商旅用车首页列表
    vehicleList: [],
    // 预定成功页面的订单列表展示
    orderList: [],
    // 使用日期表格展示
    vehTimeDateList: [],
    // 用车列表热门酒店推荐
    hotHoteList: [],
    // 用车申请日志列表
    vehLogList: []
}
const getters = {
}

const mutations = {
    setCarRules(state, data) {
        // 业务要求迎接用车要是第一个数组
        if (data && data.length > 0 && data.length === 2) {
            if (data[0].ruleType === '1') {
                state.carRules = data
            } else if (data[0].ruleType === '2') {
                let first = {}
                let two = {}
                first = data[0]
                two = data[1]
                state.carRules = [two, first]
            }
        } else {
            state.carRules = data
        }
    },
    setSelectedTime(state, data) {
        state.dateTimeStr = data
    },
    setVehicleWay(state, data) {
        state.vehicleWay = data
    },
    setVehicleLock(state, data) {
        state.lockInfo = data
    },
    setVehicleTime(state, data) {
        state.vehicleTimeSet = data
    },
    saveCommitData(state, data) {
        state.commitData = data
    },
    clearVehicleData(state) {
        state.carRules = []
        state.lockInfo = {}
        state.vehicleTimeSet = {}
    },

    /**
     * 用于用车列表右侧删除时，关联左侧改变数据
     * @param {*} state
     * @param {*} payload
     */
    setBusLeftData(state, payload) {
        state.busLeftData = payload
    },

    /**
     * 用于用车列表右侧数据存储展示
     * @param {*} state
     * @param {*} payload
     */
    setRigthBookingList(state, payload) {
        state.rigthBookingList = payload
    },

    /**
     * 用于存储使用已选日期
     * @param {*} state
     * @param {*} payload
     */
    setBusDateTimeList(state, payload) {
        state.busDateTimeList = payload
    },

    /**
     * 用于存储申请右侧批量列表
     * @param {*} state
     * @param {*} payload
     */
    setBusApplyRightList(state, payload) {
        state.busApplyRightList = payload
    },

    /**
     * 用于展示用车列表中日期
    */
    setIsVehicleIndex(state, payload) {
        state.isVehicleIndex = payload
    },

    /**
     * 用车类型
    */
    setBusVehicleTypeLookUp(state, payload) {
        state.vehicleTypeList = payload
    },

    /**
     * 车辆价格
    */
    setBusVehiclePriceLookUp(state, payload) {
        state.busVehiclePricelist = payload
    },

    /**
     * 乘客人数
    */
    setBusVehicleNumberLookUp(state, payload) {
        state.passengersNumberList = payload
    },

    /**
     * 乘客用途
    */
    setBusUseLookUp(state, payload) {
        state.usageOption = payload
    },

    /**
     * 用车车型
    */
    setVehicleModel(state, payload) {
        state.vehicleModelList = payload
    },

    /**
     * 用车列表
    */
    setVehicleList(state, payload) {
        state.vehicleList = payload.data
        state.busPageInfo = payload.pageInfo
    },

    /**
     * 设置分页信息
     */
    setPageVO(state, { curPage, pageSize }) {
        curPage && (state.pageVO.curPage = curPage)
        pageSize && (state.pageVO.pageSize = pageSize)
    },

    /**
     * 取消规则文本查询
    */
    setVehRulesHtml(state, payload) {
        state.vehRulesHtml = payload
    },

    /**
     * 用车时间列表服务接口
    */
    setVehTimeDate(state, payload) {
        state.vehTimeDateList = payload
    },

    /**
     * 订单团组相关的热门酒店列表服务接口
    */
    setVehHotHotel(state, payload) {
        state.hotHoteList = payload
    },

    /**
     * 订单列表查询服务接口
    */
    setVehOrderPageList(state, payload) {
        state.orderList = payload
    },

    /**
     * 用车列表日志
    */
    setVehLogList(state, payload) {
        state.vehLogList = payload
    },

    /**/
    getVehFindDurationSer() {}

}
const actions = {
    getCarRules(context, params = {}) {
        const language = context.rootState.common.lang
        const exhiId = context.rootState.common.exhiFromId
        if (!exhiId) return
        return new Promise((resolve, reject) => {
            const ruleTypeList = ['1', '2']
            const serviceDateStr = params.time
            services.vehicleSer.getCarRules({ exhiId, ruleTypeList, serviceDateStr, language }).then(({ data }) => {
                context.commit('setCarRules', data.data)
                resolve(data)
            }).catch(err => { reject(err) })
        });
    },

    /**
     * 接机牌弱提示
     */
    getReceiveSign(context, params = {}) {
        const language = context.rootState.common.lang
        const exhiId = context.rootState.common.exhiFromId
        return new Promise((resolve, reject) => {
            services.vehicleSer.getReceiveSign({ exhiId, language }).then(({ data }) => {
                resolve(data)
            }).catch(err => { reject(err) })
        });
    },
    initVehicle(context, params = {}) {
        const language = context.rootState.common.lang
        const exhiId = context.rootState.common.exhiFromId
        if (!exhiId) return
        return new Promise((resolve, reject) => {
            const ruleTypeList = ['1', '2']
            const serviceDateStr = params.time
            services.vehicleSer.getCarRules({ exhiId, ruleTypeList, serviceDateStr, language }).then(({ data }) => {
                context.commit('setCarRules', data.data)
                let timectr = {}
                data.data && data.data.length && data.data.forEach(config => {
                    let serviceStartTime = config.serviceStartTime || ''
                    let serviceEndTime = config.serviceEndTime || ''
                    if (config.ruleType === '1') {
                        state.carTypeInfo['1'] = config
                        timectr.welcomeStart = serviceStartTime.substr(0, 10)
                        timectr.welcomeEnd = serviceEndTime.substr(0, 10)
                    }
                    if (config.ruleType === '2') {
                        state.carTypeInfo['2'] = config
                        timectr.seeOffStart = serviceStartTime.substr(0, 10)
                        timectr.seeOffEnd = serviceEndTime.substr(0, 10)
                    }
                })
                const currentDate = dateUtil.formatDate(dateUtil.dateOfZone())
                const current = currentDate.substr(0, 10)
                timectr.currentDate = currentDate
                let { seeOffStart, welcomeStart, seeOffEnd, welcomeEnd } = timectr
                let minServiceDate
                // 搜索框默认值
                if (seeOffStart && welcomeStart) {
                    minServiceDate = seeOffStart > welcomeStart ? welcomeStart : seeOffStart
                } else {
                    minServiceDate = seeOffStart || welcomeStart
                }
                timectr.defaultStart = current > minServiceDate ? current : minServiceDate
                timectr.defaultEnd = seeOffEnd > welcomeEnd ? seeOffEnd : welcomeEnd
                context.dispatch('getVehicleLockInfo').then(({ data }) => {
                    const minDate = dateUtil.getLockDate(data).substr(0, 10)

                    // 迎接用车锁与当前时间比较
                    if (timectr.welcomeStart < minDate) timectr.welcomeStart = minDate
                    // 送行用车直接比较当前时间
                    if (timectr.seeOffStart < current) timectr.seeOffStart = current
                    context.commit('setVehicleTime', timectr)
                    resolve(timectr)
                })
            }).catch(err => { reject(err) })
        });
    },
    getVehicleWays(context, params) {
        return new Promise((resolve, reject) => {
            let exhiId = context.rootState.common.exhiFromId
            let classifyCode = '0203'
            services.vehicleSer.getVehicleLookUp({ exhiId, classifyCode }).then(({ data }) => {
                context.commit('setVehicleWay', data.data)
                resolve(data)
            })
        });
    },
    getVehicleLockInfo(context, params) {
        return new Promise((resolve, reject) => {
            let exhiId = context.rootState.common.exhiFromId
            let reqType = '009'
            let lockType = '004'
            services.vehicleSer.getVehicleLockInfo({ exhiId, reqType, lockType }).then(({ data }) => {
                context.commit('setVehicleLock', data.data || {})
                resolve(data)
            })
        });
    },

    /**
     * 用车类型lookUp查询
    */
    getBusVehicleTypeLookUp(context, params) {
        return new Promise((resolve, reject) => {
            services.commonSer.getLookUpData(params).then((data) => {
                if (data.data.data) {
                    data.data.data.forEach(res => { res.codes = 'vehtype' })
                }
                context.commit('setBusVehicleTypeLookUp', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 用车价格lookUp查询
    */
    getBusVehiclePriceLookUp(context, params) {
        return new Promise((resolve, reject) => {
            services.commonSer.getLookUpData(params).then((data) => {
                if (data.data.data) {
                    data.data.data.forEach(res => { res.type = 'price' })
                }
                context.commit('setBusVehiclePriceLookUp', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 乘车人数lookUp查询
    */
    getBusVehicleNumberLookUp(context, params) {
        return new Promise((resolve, reject) => {
            services.commonSer.getLookUpData(params).then((data) => {
                if (data.data.data) {
                    data.data.data.forEach(res => { res.type = 'passengersNumber' })
                }
                context.commit('setBusVehicleNumberLookUp', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 乘车用途lookUp查询
    */
    getBusUseLookUp(context, params) {
        return new Promise((resolve, reject) => {
            services.commonSer.getLookUpData(params).then((data) => {
                context.commit('setBusUseLookUp', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 获取车辆取消规则接口
    */
    findReceiveClassesInfoAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.findReceiveClassesInfo(params).then((data) => {
                resolve(data.data || {})
            })
        })
    },

    /**
     * 获取车辆取消规则接口
    */
    getVehRule(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehRuleSer(params).then((data) => {
                context.commit('setVehRulesHtml', data.data.data || '')
                resolve(data.data.data)
            })
        })
    },

    /**
     * 押车预定首页获取车型服务接口
    */
    getVehTypeList(context, params) {
        const language = context.rootState.common.lang
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehTypeList(params).then((data) => {
                if (data.data.data) {
                    data.data.data.forEach(item => {
                        item.itemName = language === 'zh_CN' ? item.vehNameCn : item.vehNameEn
                        item.itemCode = item.configId
                        item.type = 'vehicleModel'
                    })
                }
                context.commit('setVehicleModel', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 商旅用车列表服务接口
    */
    getVehList(context, params) {
        const createdBy = context.rootState.common.user.createdBy
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehList(params).then((data) => {
                if (data && data.data && data.data.data) {
                    data.data.data.forEach(res => {
                        // 用量
                        res.dayUseAmount = 0
                        // 用时
                        res.dayUseTime = 0
                        // 当前登录账号
                        res.createdBy = createdBy
                    })
                }
                context.commit('setVehicleList', data.data || {})
                context.commit('setPageVO', data.data.pageInfo || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 用车时间列表服务接口
    */
    getVehTimeDate(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehTimeDate(params).then((data) => {
                context.commit('setVehTimeDate', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 订单团组相关的热门酒店列表服务接口
    */
    getVehHotHotel(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehHotHotel(params).then((data) => {
                context.commit('setVehHotHotel', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 订单列表查询服务接口
    */
    getVehOrderPageList(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderPageList(params).then((data) => {
                context.commit('setVehOrderPageList', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 提交车辆预定服务接口
    */
    getVehOrderSubmitAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderSubmitSer(params).then((data) => {
                resolve(data)
            })
        })
    },

    /**
     * 提供修改订单查询订单详情
    */
    getVehOrderByEditAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderByEditSer(params).then((data) => {
                resolve((data && data.data && data.data.data) || {})
            })
        })
    },

    /**
     * 查询人员信息
     * @param {*} context
     * @param {*} params
     */
    getVehInfoAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehInfoSer(params).then((data) => {
                resolve((data && data.data && data.data.data) || {})
            })
        })
    },

    /**
     * 订单保存服务接口
    */
    getVehOrderSave(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderSave(params).then((data) => {
                resolve(data)
            })
        })
    },

    /**
     * 车辆订单编辑服务
    */
    getVehOrderEditAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderEditSer(params).then((data) => {
                resolve(data)
            })
        })
    },

    /**
     * 车辆订单取消服务
    */
    getVehOrderCancelAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehOrderCancelSer(params).then((data) => {
                resolve(data)
            })
        })
    },

    /**
     * 查询mrs团组信息soa接口
    */
    getVehMgrGroupListAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehMgrGroupListSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 查询ems团组信息soa接口
    */
    getEMSGroupNoListAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getEMSGroupNoListSer(params).then((data) => {
                resolve(data.data)
            }).catch(err => { reject(err) })
        })
    },

    /**
     * 查询Icim团组信息soa接口
    */
    getVehIcimGroupListAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehIcimGroupListSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 查询用车列表日志
    */
    getVehLogAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehLogSer(params).then((data) => {
                context.commit('setVehLogList', data.data.data || {})
                resolve(data.data.data)
            })
        })
    },

    /**
     * 查询用车申请费用查询
    */
    getVehFeeCalAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehFeeCalSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 根据时间段查询用时用量
    */
    getVehFindDurationAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehFindDurationSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 根据车型段查询用时用量
    */
    getVehFindTimeAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehFindTimeSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 根据押车用途查询车型
    */
    getVehSelectionAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehSelectionSer(params).then((data) => {
                resolve(data.data.data)
            })
        })
    },

    /**
     * 提供根据时间判断所选车型余量是否充足服务
     */
    getVehMarginJudAct(context, params) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehMarginJudSer(params).then((data) => {
                resolve(data)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
